import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import {BsChevronDoubleRight, BsGeoAlt, BsTelephone, BsEnvelope, BsWhatsapp} from "react-icons/bs";
import { BiLogoFacebook, BiLogoTwitter, BiLogoYoutube, BiLogoLinkedin, BiLogoInstagram } from "react-icons/bi";
import axiosInstance from '../axiosInstance';

const Footer = () => {
  const [contactData, setContactData] = useState(null);
  const [socialMediaData, setSocialMediaData] = useState(null);
  const [projectData, setProjectData] = useState([]);

  useEffect(() => {
    const fetchAllData = async () => {
        try {
            const token = localStorage.getItem("token");

            const [contactRes, socialRes, projectRes] = await Promise.all([
                axiosInstance.get('/api/fetchcontactnew', {
                    headers: {
                        Authorization: `${token}`,
                    }
                }),
                axiosInstance.get('/api/fetchsocialmedia'),
                axiosInstance.get('/api/getprojects')
            ]);

            if (contactRes.data?.length > 0) {
                setContactData(contactRes.data[0]);
            }

            if (socialRes.data?.length > 0) {
                setSocialMediaData(socialRes.data[0]);
            }

            if (projectRes.data?.length > 0) {
                setProjectData(projectRes.data);
            }

        } catch (err) {
            console.error("Failed to fetch data:", err);
        }
      };

      fetchAllData();
    }, []);
    return (
        <section className="footer relative bg-slate-950">
          <div className='block group' id='whatsapp-chat-widget'>
            <div className='fixed mb-5 z-50 bottom-0 right-3 w-12 h-12 rounded-full border border-emerald-600 border-solid bg-emerald-600 text-white flex justify-center items-center cursor-pointer shadow-sm shadow-gray-600 visible'>
              <Link to={socialMediaData?.whatsapp || "#"} target="_blank" className='text-3xl text-white block'><BsWhatsapp /></Link>
            </div>
            <div className='fixed bottom-8 right-3 z-50 mb-9 mr-9 hidden group-hover:flex items-center transition-all translate-x-full translate-y-full group-hover:translate-y-0 group-hover:translate-x-0'>
              <div className=' bg-white border border-zinc-900 border-solid rounded-3xl rounded-br-none text-zinc-900 shadow-md shadow-emerald-500'>
                <Link to={socialMediaData?.whatsapp || "#"} target='_blank' className='block px-4 py-2 text-sm text-zinc-900 font-medium'>Chat with Us</Link>
              </div>
            </div>
          </div>
          <div className='container mx-auto relative'>
            <div className='flex md:flex-row flex-col py-9'>
              <div className='w-full px-8 sm:px-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 grid-flow-row auto-rows-auto gap-9 text-slate-400 font-light text-sm leading-6'>
                <div className='flex flex-col'>
                  <h3 className='relative text-base leading-7 font-medium text-white uppercase font-montserrat pb-1 mb-4'>
                    About Us
                    <span className="absolute bottom-0 left-0 -mb-0.5 h-0.5 w-12 bg-orange-400"></span>
                  </h3>
                  <p>A mastermind in real estate development, Urbanaid Infratech, is a name synonymous with trend setting in large-scale and luxurious communities. With a versatile vision to uphold the highest loyalty, quality and royalty in the region, this reputed company takes pride in delivering projects par excellence.</p>
                </div>
                <div className='flex flex-col'>
                  <h3 className='relative text-base leading-7 font-medium text-white uppercase font-montserrat pb-1 mb-4'>
                    Company Links
                    <span className="absolute bottom-0 left-0 -mb-0.5 h-0.5 w-12 bg-orange-400"></span>
                  </h3>
                  <div className='flex flex-col'>
                    <ul className='flex flex-col gap-2'>
                        <li className='flex flex-row align-middle items-center'><BsChevronDoubleRight className='text-[10px] me-2' /> <Link to={'/archives'} className='hover:text-orange-600 font-normal'>Archives</Link></li>
                        <li className='flex flex-row align-middle items-center'><BsChevronDoubleRight className='text-[10px] me-2' /> <Link to={'/about-us'} className='hover:text-orange-600 font-normal'>About Us</Link></li>
                        <li className='flex flex-row align-middle items-center'><BsChevronDoubleRight className='text-[10px] me-2' /> <Link to={'/videos'} className='hover:text-orange-600 font-normal'>Videos</Link></li>
                        <li className='flex flex-row align-middle items-center'><BsChevronDoubleRight className='text-[10px] me-2' /> <Link to={'/testimonials'} className='hover:text-orange-600 font-normal'>Testimonials</Link></li>
                        <li className='flex flex-row align-middle items-center'><BsChevronDoubleRight className='text-[10px] me-2' /> <Link to={'/contact-us'} className='hover:text-orange-600 font-normal'>Contact Us</Link></li>
                    </ul>
                  </div>
                </div>
                <div className='flex flex-col'>
                  <h3 className='relative text-base leading-7 font-medium text-white uppercase font-montserrat pb-1 mb-4'>
                    Projects
                    <span className="absolute bottom-0 left-0 -mb-0.5 h-0.5 w-12 bg-orange-400"></span>
                  </h3>
                  <div className='flex flex-col flex-wrap gap-3 text-xs uppercase'>
                    {Array.isArray(projectData) && projectData.length > 0 ? (
                      projectData.map((project) => {
                      const projectUrl = project.projectname?.toLowerCase().replace(/\s+/g, '-') || '';
                      return (
                      <Link key={project.id ?? project.projectname} to={`/projects/${projectUrl}`} className='px-4 py-1 border border-solid border-slate-600 hover:bg-slate-600 hover:text-white'>{project.projectname}</Link>
                      )
                    })
                    ) : (
                    <span className="px-3 py-2 text-gray-400">No projects found</span>
                    )}
                      {/* <div className='px-4 py-1 border border-solid border-slate-600'>Link 1</div>
                      <div className='px-4 py-1 border border-solid border-slate-600'>Link 1</div>
                      <div className='px-4 py-1 border border-solid border-slate-600'>Link 1</div>
                      <div className='px-4 py-1 border border-solid border-slate-600'>Link 1</div> */}
                  </div>
                </div>
                <div className='flex flex-col'>
                  <h3 className='relative text-base leading-7 font-medium text-white uppercase font-montserrat pb-1 mb-4'>
                    Contact Info
                    <span className="absolute bottom-0 left-0 -mb-0.5 h-0.5 w-12 bg-orange-400"></span>
                  </h3>
                  <ul className='flex flex-col gap-3'>
                      <li className='grid grid-cols-[1fr_11fr] gap-2'><BsGeoAlt className='text-xl mt-1' /> {contactData?.officeaddress || 'Loading...'}</li>
                      <li className='grid grid-cols-[1fr_11fr] gap-2'><BsTelephone className='text-lg mt-1' /> <div>{contactData?.mobile?.map((mobile, idx) => (<span key={idx}>+91-{mobile} {idx !== contactData.mobile.length - 1 && ', '}</span>))}</div></li>
                      <li className='grid grid-cols-[1fr_11fr] gap-2'><BsEnvelope className='text-lg mt-1' /> <div>{contactData?.email?.map((email, idx) => (
                                                          <React.Fragment key={idx}>
                                                            <Link to={`mailto:${email}`} className="hover:text-orange-500 font-semibold">
                                                              {email}
                                                            </Link>
                                                            {idx !== contactData.email.length - 1 && ', '}
                                                          </React.Fragment>
                                                      ))}</div></li>
                      <li className='flex flex-row flex-wrap gap-3'>
                          <Link to={socialMediaData?.facebook || "#"} target="_blank" rel="noopener noreferrer" className='px-1 py-1 text-base border border-solid border-slate-600 hover:text-white hover:border-orange-500 hover:bg-orange-500'><BiLogoFacebook /></Link>
                          <Link to={socialMediaData?.twitter || "#"} target="_blank" rel="noopener noreferrer" className='px-1 py-1 text-base border border-solid border-slate-600 hover:text-white hover:border-orange-500 hover:bg-orange-500'><BiLogoTwitter /></Link>
                          <Link to={socialMediaData?.youtube || "#"} target="_blank" rel="noopener noreferrer" className='px-1 py-1 text-base border border-solid border-slate-600 hover:text-white hover:border-orange-500 hover:bg-orange-500'><BiLogoYoutube /></Link>
                          <Link to={socialMediaData?.linkedin || "#"} target="_blank" rel="noopener noreferrer" className='px-1 py-1 text-base border border-solid border-slate-600 hover:text-white hover:border-orange-500 hover:bg-orange-500'><BiLogoLinkedin /></Link>
                          <Link to={socialMediaData?.instagram || "#"} target="_blank" rel="noopener noreferrer" className='px-1 py-1 text-base border border-solid border-slate-600 hover:text-white hover:border-orange-500 hover:bg-orange-500'><BiLogoInstagram /></Link>
                      </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className='footer-bottom py-4 bg-black'>
                <div className="container mx-auto">
                    <div className="flex flex-col md:flex-row text-sm font-normal leading-5 text-slate-500 justify-between items-center">
                        <div>Copyright Urbanaid Infratech. All rights reserved.</div>
                        <div>Designed and Developed by <Link to={''}>Webgate Informatics</Link></div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Footer;
